import React from 'react';
import { MarketHeader } from '../../../components/MarketHeader';
import { CompanyPageHeader } from '../../../components/CompanyPageHeader';
import { LOCATION_DESCRIPTIONS } from '../../../utils/constants/location-descriptions';

export interface SearchHeaderProps {
  location: string | null;
  companyId: string | null;
  locale: 'en' | 'fi' | 'sv';
  nbHits: number;
  locationTrendsData?: any;
  className?: string;
}

/**
 * Search header component - shows MarketHeader for location searches or CompanyPageHeader for company searches
 */
export const SearchHeader: React.FC<SearchHeaderProps> = ({
  location,
  companyId,
  locale,
  nbHits,
  locationTrendsData,
  className = '',
}) => {
  if (location) {
    const locationDescription = LOCATION_DESCRIPTIONS[location]?.[locale];
    return (
      <section className={`-mx-2 sm:-mx-2 md:-mx-2 lg:-mx-8 -mt-1 sm:-mt-1 md:-mt-2 ${className}`} aria-labelledby="location-header-title">
        <MarketHeader
          location={location}
          nbHits={nbHits}
          description={locationDescription}
          locationTrendsData={locationTrendsData}
        />
      </section>
    );
  }

  if (companyId) {
    return (
      <section className={`sm:px-0 md:px-2 ${className}`} aria-labelledby="company-header-title">
        <CompanyPageHeader companyId={companyId} />
      </section>
    );
  }

  return null;
};
